var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 9.2 12",
    style: {
      enableBackground: "new 0 0 9.2 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,4c0.3,0,0.6,0.1,0.8,0.3C9,4.6,9.2,4.8,9.2,5.1v5.7c0,0.3-0.1,0.6-0.3,0.8C8.6,11.9,8.3,12,8,12H1.2 c-0.3,0-0.6-0.1-0.8-0.3S0,11.2,0,10.9V5.1c0-0.3,0.1-0.6,0.3-0.8S0.8,4,1.2,4h0.6V2.9c0-0.8,0.3-1.5,0.8-2S3.8,0,4.6,0 s1.5,0.3,2,0.8s0.8,1.2,0.8,2V4H8z M6.3,4V2.9c0-0.5-0.2-0.9-0.5-1.2C5.5,1.3,5.1,1.1,4.6,1.1S3.7,1.3,3.3,1.6S2.8,2.4,2.8,2.9V4 H6.3z M3.8,8.8C4,9,4.3,9.2,4.6,9.2S5.2,9,5.4,8.8C5.6,8.6,5.7,8.3,5.7,8c0-0.3-0.1-0.6-0.3-0.8C5.2,7,4.9,6.9,4.6,6.9S4,7,3.8,7.2 C3.5,7.4,3.4,7.7,3.4,8C3.4,8.3,3.5,8.6,3.8,8.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.91629253dd00ab05a2d76ace8253a2ef.svg";
export { ForwardRef as ReactComponent };